import { type SVGProps } from "react";

const variantStates = {
  colored: {
    gradient: ["#9E77ED", "#9972EA", "#8D66E1", "#7A52D2", "#6941C6"],
  },
  white: {
    gradient: ["white", "white", "white", "white", "white"],
  },
};

export default function Logo({
  variant = "colored",
  ...props
}: SVGProps<SVGSVGElement> & { variant?: keyof typeof variantStates }) {
  const gradientId = `logo-gradient-${variant}`;
  const gradientColors = variantStates[variant].gradient;

  return (
    <svg
      width={props.width || 34}
      height={props.height || 24}
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="17.4213"
          y1="2.57627"
          x2="17.4213"
          y2="21.0888"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientColors[0]} />
          <stop offset="0.27" stopColor={gradientColors[1]} />
          <stop offset="0.54" stopColor={gradientColors[2]} />
          <stop offset="0.82" stopColor={gradientColors[3]} />
          <stop offset="1" stopColor={gradientColors[4]} />
        </linearGradient>
      </defs>
      <path
        d="M25.2833 10.3815C26.1756 9.48742 27.6214 9.48743 28.5137 10.3815L32.3272 14.2028C34.5576 16.4376 34.5576 20.0597 32.3272 22.2946C30.0967 24.5294 26.4815 24.5294 24.251 22.2946L19.7237 17.7594C18.3332 16.3662 16.079 16.3662 14.6885 17.7594L9.12994 23.3297C8.23761 24.2238 6.79082 24.2238 5.89849 23.3297C5.00621 22.4357 5.00626 20.9865 5.89849 20.0924L11.4922 14.4879C14.648 11.326 19.7648 11.326 22.92 14.4879L27.7061 19.2838C28.1474 19.7259 28.8618 19.7311 29.3096 19.2955C29.7664 18.8508 29.7717 18.1175 29.3213 17.6656L25.2833 13.6188C24.3911 12.7247 24.3911 11.2765 25.2833 10.3824V10.3815ZM18.796 20.7506C19.6901 20.7507 20.414 21.4765 20.4141 22.3717C20.4141 23.2677 19.6895 23.9937 18.796 23.9938H15.6172C14.723 23.9938 13.9981 23.2671 13.9981 22.3717C13.9983 21.4758 14.7237 20.7506 15.6172 20.7506H18.796ZM15.5909 0.67053C16.4832 -0.223524 17.929 -0.223495 18.8213 0.67053C19.7137 1.56458 19.7136 3.01278 18.8213 3.90686L4.28326 18.4742C3.39099 19.368 1.94507 19.368 1.05279 18.4742C0.160463 17.5802 0.160463 16.131 1.05279 15.2369L15.5909 0.67053Z"
        fill={`url(#${gradientId})`}
      />
    </svg>
  );
}
